import isEqual from 'lodash/isEqual';

let prevVisibleUserLayers: string[] = [];

export default function trackLayerAnalytics(isAuthenticated: boolean, userLayers?: UserLayer[]) {
    if (!isAuthenticated) return;

    if (!userLayers) return;

    // track map source usage for internal reporting
    const visibleUserLayers = userLayers
        .filter(({isVisible}) => isVisible)
        .map(({layer}) => layer.type)
        .sort();

    if (isEqual(prevVisibleUserLayers, visibleUserLayers)) return;

    prevVisibleUserLayers = visibleUserLayers;

    fetch('/api/mapsources/track/', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({
            device_udid: 'web',
            map_layers: visibleUserLayers,
        }),
    }).catch(console.warn);
}
